import React, { useState, useEffect, useId, useCallback} from "react";

import { Link, Navigate, useNavigate, useSearchParams} from "react-router";
import Logo from "./common/Logo";


import Template from "./common/template/Template";
import AlertBox from "./common/template/AlertBox";

import UserService from "../services/user.service";
import AuthService from "../services/auth.service";

import { useAuth } from "../context/AuthContext";


//import RenderPuntosForm from "./Puntos"

import FlashMessage from "./common/FlashMessage";
import Loading from "./common/template/Loading";

import SaveButton from "./common/template/SaveButton";

const wrapperClass = `w-full h-full p-4 mt-16  mb-4 mx-auto  rounded-lg md:rounded-b-none  shadow-md bg-white`;

const isFlashMessage = localStorage.getItem('cmx_flashMessage');
console.log('found a flashMessage in localstorage?',isFlashMessage)

const backUrl = process.env.REACT_APP_BACK_URL;

export default function Eval () {

    const { user } = useAuth();


   const navigate = useNavigate();
   
   const [flashMessage,setFlashMessage] = useState(false)
    
    const [instance, setInstance] = useState(false);
    const [selectedCheck, setSelectedCheck] = useState("");
   // const [loading, setLoading] = useState(false);
    //const [message, setMessage] = useState(false);
    const [content, setContent] = useState('');
    const [state, setState] = useState(false);
    const [criterios, setCriterios] = useState('');
    const [current, setCurrent] = useState('');

    //simple strings for the buttons, choose your own!
    const strSave = `Aceptar y Continuar`;
    const strCancel = `❌ Cancelar `;

     // Destructure the returned array with standard names
    const [searchParams, setSearchParams] = useSearchParams();

    // Use the .get() method to access a specific value
    const evalId = searchParams.get("eId");
    
    // Example of using the setter function
    const updateEvalId = (newId) => {
      setSearchParams({ evalId: newId });
    };

    const [error, setError] = useState(false)

    

    useEffect(() => {

      //this blocks the app from scrolling
      //document.body.style.overflow = "hidden";
        
      try { 

        UserService.getEvalState(evalId,user).then(

            (response) => {

              console.log(content);
              
              console.log(response);
              //console.log(response.status);
              if(response  ){
                  setContent(response.data);
                  setInstance(response.data.state.instance_key);
                  setState(response.data.state);
                  setCriterios(response.data.criterios);
                  setCurrent(response.data.current);

              } else {
                navigate('/login')
              }

              
            
            },

            (error) => {
              console.log(error)
              const _content =
                (error?.response && error?.response.data) ||
                error?.message ||
                error?.toString();
              
              setError(_content);
              
              
            
            }
          
        )
          
      } catch (error) {

        console.log(error)
        //navigate("/login")
          
      } finally {
        if(isFlashMessage){
          setFlashMessage(isFlashMessage);
        }
      }
        
     //console.log(flashMessage)
      // Clean up the event listener when the component unmounts
      return () => {
        //this is the reset state of the scroll blocking above
        //document.body.style.overflow = "scroll"
 

    };
  
    }, [] );

    

    const CancelButton = ({className, children}) => {

      const [loading,setLoading] = useState(false);

      function handleClick(){

        setLoading(true);
        handleCancel();

      }

      return (  
         
        <button  
                type="button"
                className={className ||
                  `m-1 p-2 flex flex-row  
                   rounded-md font-semibold 
                   hover:ring-red-400 ring-1 ring-zinc-200 text-zinc-400  hover:text-red-400 hover:shadow-lg
                  transition-all delay-75
                  `
                } 
                disabled={loading} onClick={handleClick}>
          
          <span className="mx-1 text-xs font-thin hover:no-underline">{children}</span>
            
        </button>
  
      );
    } 
    
    function handleCancel (){
      
        
         
         localStorage.setItem('cmx_flashMessage',JSON.stringify({
            message: 'Evaluacion cancelada por el usuario. Atención: no olvide terimnar la evaluacion más adelante  ya que el tiempo seguira transcurriendo.',
            type: 'warning',
          }));
       
        
        console.log('cancelled by the user');
       
        setContent(false); 
        navigate(-1);
        
      
    }

    const BackButton = ({className, children}) => {

      const [loading,setLoading] = useState(false);

      function handleClick (){
      
        setLoading(true);
        
        localStorage.setItem('cmx_flashMessage',JSON.stringify({
            message:'Evaluación finalizada correctamente!',
            type:'info'}));
        navigate('/mycompliance');
        
        
      
      }
    
      return (        
  
  
        <button  
                type="button"
                className={className +
                  `m-1 p-2 
                   rounded-md 
                  hover:bg-white bg-zinc-50 border border-zinc-400 font-semibold
                  
                  `
                } 
                disabled={loading} onClick={handleClick}>
          
          <span className="mx-1 text-zinc-400 text-xs font-thin hover:no-underline">{children}</span>
            
        </button>
  
      );
    } 


    const RenderStart = ()=> {
      
      
      const [loading,setLoading] = useState(null);
      const options = createOptions();
      console.log(options);
      
      function createOptions() {
        return {
          //evalId: inputEvalId.current.value, 
          //instance: inputInstanceKey.current.value,
          evalId: evalId, 
          instance: content.state.instance_key,
          
          selectedCheck: selectedCheck,
          obs: '',     
                   
        };
      }


      function handleSubmit(event) {

        event.preventDefault();
        setLoading(true)
        //setSelectedCheck(1);
        //setObs(''); 
        setInstance(0);  
         
        //this just dummy data for the axios call to work, it won't be used in the backendAPI
        const data = {

          criterio: 9999,
          obs: 'starting'

        }

        try{

          UserService.setPunto(options.evalId, options.instance, user, data )
            .then(
              (response) => {
              
                  console.log(response);              
                  //console.log(response.status);
                  //console.log(response.statusText)
    
                  //console.log(response);              
                  console.log(response.status);
                  console.log(response.statusText)


                  
                  if(response.status === 200){
                    
                     setContent(response.data);                 
                    localStorage.setItem('cmx_flashMessage',JSON.stringify({
                      message : 'Evaluación Iniciada satisactoriamente!',
                      type : 'success',

                    }));
                    //CancelProcessing();
                    navigate(0)
                   
                  } else {
                      
                   
                    setFlashMessage({
                      'message' : response.statusText,
                      'type' : 'error',

                    })
                    
                  }
                  
                  
                  //return content;
  
              },
              
                (error) => {
                  console.log(error)
                  setError(error.messages)
                  //CancelProcessing();
                }
              );

        } catch (error) {


           console.log(error)
            setError(error.messages)

        }
            
        

        
        
      }     

      return(
  
          <form onSubmit={handleSubmit} >
  
            <div className=" flex flex-col 
                   sm:justify-start 
                  sm:w-fit my-2
                  ">
                    <p className="text-sm font-thin text-slate-700 ">
                      Usted esta a punto de comenzar la evaluacion&nbsp;
                      <span className=" font-bold">
                        Nº  {evalId}</span> <sup className="text-[9px]">[{instance}]</sup>
                      .
                    </p>
                      <div className="alert alert-info" >
                        <span className="text-sm font-light ">
                      A partir de este punto el tiempo de inicio y transcurrido hasta finalizar la evaluacion sera registrado. 
                      </span>
                      </div>
                    
                    
                    
                         
            </div>   
            {error && (
                          
                          <div className="alert alert-danger " role="alert">
                              {error}
                          </div>
                                  
            )}      
    
            <div className="flex justify-around">            
                  
                    <SaveButton disabled={loading}
                      >
                         {strSave}
                    </SaveButton>
                    
                    <CancelButton 
                      >
                        {strCancel}
                    </CancelButton>   
              
            </div>

          </form>
        
      );
  
    }

    const RenderInstance = () => { 
   

      //const [isView, setIsView] = useState(task.task_is_complete);
      const [selectedFile, setSelectedFile] = useState(null);

      const [selectedFiles, setSelectedFiles] = useState([]);
      
      const [isChecked, setIsChecked] = useState(false);
      const [obs, setObs] = useState("");

      const [loading,setLoading] = useState(false);
        
      const labelClassName = ` hover:bg-zinc-50  hover:shadow-md p-1 rounded-md flex items-center `;
      const inputClassName = ` mr-2 w-8 h-8`;

      //var steps = Object.keys(criterios).length;
      
      
      function handleSubmit(event) {

        event.preventDefault();

        setLoading(true);
        

        const form = event.target;

        const formData = new FormData(form);

        //append the uploaded image to the formData object, like...this is the right way i guess
        
        //formData.append('image', selectedFile);
        selectedFiles.forEach((file) => {
          formData.append('files', file);
        });
        
        const values = [...formData.entries()];
        const formElements = form.elements;
        
        const onSubmitObs = formData.get("obs");
        const onSubmitRadio = formData.get("criterio-verif");

        const onSubmitPhoto = formData.get("image");
        
        //console.log(values);
        
        //console.log(form);
        
        //console.log(formElements);
        
        console.log(onSubmitObs);

        console.log(onSubmitRadio);
        
       

        if (!error) {
                    
          const data = {

            criterio: parseInt(formData.get("criterio-verif")),
            obs: formData.get("obs"),
            
          }
          console.log(data);

          try{
            UserService.setPunto(evalId, instance, user, formData )
              .then(
                (response) => {
                
    
                    setContent(response.data);
                    
                    if(response.status === 204){
                      setError(error + response.statusText)

                      localStorage.setItem('cmx_flashMessage',JSON.stringify({
                        message:'error status 204:duplicate entry maybe?',
                        type:'warning'
                     }));
                      //CancelProcessing();
                      navigate(0);
                    }
                    
                    console.log(response);              
                    //console.log(response.status);
                    //console.log(response.statusText)
      
                    //console.log(response);              
                    console.log(response.status);
                    console.log(response.statusText)
                    
                    //if(response.data.message !== undefined){
                      console.log(response.data?.message)
                    if(response.error){

                        setFlashMessage({
                      message : response.error,
                      type : 'error'
                     })

                    } else {
                      localStorage.setItem('cmx_flashMessage',JSON.stringify({
                        message: "Evaluación actualizada satisfactoriamente!",
                        type : 'success'
                      }));
                    }
                      
                    if(!response.data.current){
                      setCurrent(null);
                      
                    } else {
                      
                      setCurrent(response.data.current);
                    }
                    
                    setCriterios(response.data.criterios);
                    setState(response.data.state)
                    setInstance(response.data.state.instance_key)
                    
                    
                    //return content;
                    navigate(0)
                }
                ,
                  (error) => {
                    const resMessage =
                      (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                      error.message || error.statusText ||
                      error.toString();
                    //setMessage(resMessage);
                    
                    setError(resMessage)
                    setFlashMessage({message:resMessage,type:'error'})
                    
                    setSelectedCheck(null);
                    
                    
                    //CancelProcessing();
                  }
                
              )    
          } catch(error) {

            console.log(error)

            
          }
              
          
        }       
        

        
        
      }      
        
      function handleChange(e){

          const value = e.target.value;
  
          console.log(value);
  
          return setObs(value);
  
          
  
      }

       
      return(
    
          <form id="eval" onSubmit={handleSubmit}  className="" encType="multipart/form-data">

            <div className="flex flex-col p-2 border rounded-md border-slate-700 bg-neutral-50 text-wrap ">
                    <h3 className="text-sm font-thin bg-slate-200">
                      
                      <span className="text-red-400 font-bold">
                        Criterio  Nº&nbsp;{parseInt(state.instance_key)+1}
                        <sup className="font-thin text-slate-600 text-[8px]">[{current.id}]</sup>
                      </span>: &nbsp; 
                      <span className="text-slate-700 font-bold">
                        {current.titulo}
                        
                      </span>
                    </h3>
                    
                    <h4 className="text-sm font-thin text-zinc-700 bg-slate-100 text-left text-ellipsis overflow-hidden ">Descripcion: {current.descripcion}</h4>
                    

                    <div className="flex flex-row justify-evenly">

                        
                            <label htmlFor={`criterio-pasa`} className={`` + labelClassName}>    
                              <input type="radio"
                                    id={`criterio-pasa`}
                                    name={`criterio-verif`}
                                    value={1}
                                    
                                    className={
                                                        
                                      inputClassName + ` `
                  
                                    } 
                                    
                                    onChange={(e)=>{
                                      //setIsPasaChecked(false);
                                      //setIsNoPasaChecked(true);
                                      //handleCheck(e);
                                      setIsChecked(!isChecked);
                                      console.log('selected Check noted! value:Pasa(1)' );
                  
                                    
                                    }}                                   
                              />Pasa
                            </label> 
                            <label htmlFor={`criterio-nopasa`} className={`` + labelClassName}>
                              
                              <input type="radio"
                                    id={`criterio-nopasa`}
                                    name={`criterio-verif`}
                                    value={0}
                                    
                                    className={
                                                        
                                      inputClassName + ``
                  
                                    } 
                                    
                                    onChange={(e)=>{
                                      //setIsPasaChecked(false);
                                      //setIsNoPasaChecked(true);
                                      //handleCheck(e);
                                      setIsChecked(!isChecked);
                                      console.log('selected Check noted! value: NOPasa (0)' );
                                                      
                                    }}
                            />
                              No Pasa
                            </label> 
            
                        
                       
                        
                    </div>
                    <div className="mx-auto">
                      <label htmlFor="obs" className="text-slate-700 text-sm font-thin hover:shadow-md rounded-md hover:bg-zinc-50 focus:bg-zinc-100 p-2">
                      Comentarios (opcional):
                      <textarea 
                          className={`text-sm font-thin 
                            border-zinc-800 
                            border rounded-md 
                            focus:shadow-sm 
                            focus:ring-slate-500 focus:ring-1 focus:outline-none
                            
                          `}
                          name="obs" 
                          id="obs"
                          
                          value={obs}
                          cols="32"
                          onChange={ handleChange }
                                
                      /> 

                      </label>


                    </div>
                    
                     <div className="flex justify-center flex-col ">
                        <label htmlFor={"upload-img"} className={`text-sm font-light max-w-3/4`}>Adjuntar imagen&nbsp;
                          <input type="file"
                                id={"upload-img"}
                                name="images[]"
                              
                                className={` rounded-md font-light text-[9px]`}
                                onChange={
                                  (event)=>{
                                    
                            /*

                                    const file = event.target.files[0];
                                    if (file) {
                                      console.log(file.type); // Typically "image/jpeg"
                                      console.log(file.name); // Often "image.jpg" or similar
                                      
                                      // To preview the image immediately
                                      //previewUrl = URL.createObjectURL(file);
                                    }

                                    setSelectedFile(event.target.files[0]);
                                    
                                    console.log('upload file changed',event.target.files[0]);
                                
                            */
                            const files = Array.from(event.target.files);
                            setSelectedFiles(files);


                                  }} 
                                    
                                  
                                accept="image/*" 
                                //capture="environment"
                                multiple
                          />
                          
                            
                        </label> 
                         
                        <ul>
                          {selectedFiles.map((file, index) => (
                            <li key={index}>{file.name}</li>
                          ))}
                        </ul>
                        
                      </div> 
                                
                    
                    
                        
            </div>   
              {error && (
                          
                          <div className="alert alert-danger " role="alert">
                              {error}
                          </div>
                                  
                )}      
    
            <div className=" flex justify-evenly my-2">
                
                
                
                  
                    <SaveButton disabled={loading}
                      >
                        {strSave}
                    </SaveButton>
                    
                    <CancelButton 
                       >
                        {strCancel}
                    </CancelButton>           
                    
                  
                
                
              
            </div>
    
    
            
          </form>
        
      );

      
  
    }

    const RenderFinish = ()=> { 
   
      return(
  
          
        <>
            <div className="flex flex-col p-2 border rounded-md border-slate-700 bg-neutral-50 text-wrap ">
                    <p className="text-lime-600 font-semibold text-base ">
                
                      Evaluación finalizada.&nbsp;                     
          
                     
                    </p>
                                             
            </div>   
                  
    
            <div className=" flex sm:pl-12 sm:w-8/12 justify-evenly sm:justify-start my-2">
                
                    
                    <BackButton 
                      className=" ">
                        ↩️ Volver
                    </BackButton>           
                    <a href={`${backUrl}/reports/eval/${evalId}/${state.read_code}`} rel="noopener noreferrer" target="_blank"
                      className="hover:no-underline text-zinc-400 hover:text-zinc-400 m-1 p-3 rounded-md bg-zinc-50 hover:bg-white border-slate-700 border text-xs font-thin">
                        📋 Ver Reporte
                    </a>
                  
              
            </div>
    
        </>
            
          
        
      );

  
    }

    console.log('is there a flashMessage',flashMessage)


    return (
        
    <Template > 
      <div 
        className={`      `+wrapperClass}>
          

                      {flashMessage && (
                  
                        <FlashMessage 
                          flashMessage={flashMessage} 
                          
                          setFlashMessage={setFlashMessage} 
                          
                         
                        />
                      
                      )}  
                

             
                          
                     

                  <div className="flex-col mx-auto md:max-w-[50vw] justify-left w-full mb-2">

                    

                      

                    {content ? (  

                    <div className="flex flex-col w-full">           
                      
                      <div id="head-eval" className="flex-col  bg-neutral-50 rounded-md border  border-slate-700 p-1 w-full mb-2">
                        
                          <h3 className="m-1                       
                          text-stone-500 text-base md:text-lg 
                            ">
                            📋&nbsp;Evaluation&nbsp;&nbsp;<span className="text-red-400">N°{evalId}</span>
                          </h3>
                          <p className="text-zinc-600 text-[10px] sm:text-sm font-thin m-0 pl-1">
                            <strong className="font-bold">Fecha Planificada:&nbsp;</strong> 
                            {state.date_inicio_planif ? (`${state.date_inicio_planif}`):('n/a')
                            }
                            
                          </p>
                          <p className="text-zinc-600 text-[10px] sm:text-sm font-thin m-0 pl-1">
                            <strong className="font-bold">Estado:&nbsp;</strong> 
                            {state.estado}
                            
                          </p>
                          {state.estado === 'Iniciada' ? (
                              <p className="text-zinc-600 text-[10px] sm:text-sm font-thin m-0 pl-1">
                              <strong className="font-bold">Criterio:&nbsp; </strong>
                              <span className="font-thin">{parseInt(state.instance_key)+1} de {Object.keys(criterios).length}</span>
                                
                              
                              </p> 
                            ) : ('')
                          }
                        
                      </div>
                      <div id="body-eval" className="" >  
                             
                             
                              {(current) ? (

                                <RenderInstance />

                              ) : (

                                (state.estado === 'Finalizada') ? (
                                  <RenderFinish  />
                                ) : (
                                  <RenderStart  />
                                )  
                                

                              )}
                      </div>
                      
                    </div>

                    ) : (

                      <div className="flex z-50 mx-auto items-center justify-center w-fit rounded-lg bg-opacity-75 bg-black p-3 mt-16">
                            <svg className="animate-spin h-10 w-10 fill-white" viewBox="0 0 24 24">
                              <path opacity="0.3" fillRule="evenodd" clipRule="evenodd" d="M12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" />
                              <path d="M2 12C2 6.47715 6.47715 2 12 2V5C8.13401 5 5 8.13401 5 12H2Z" />
                            </svg>
                            <span className="text-white font-extralight ml-2">Loading...</span>
                      </div>

              
                    )}

                  </div>
                    
                          

                </div>
              
                
            
                              
          
        
        </Template>   
        
    );

} 

  
  



